
import { useParams } from "react-router-dom";
import { useLead } from "@/hooks/useLeads";
import { LeadDetail as LeadDetailComponent } from "@/components/leads/LeadDetail";
import { LoadingState } from "@/components/error-handling/LoadingState";
import { ErrorState } from "@/components/error-handling/ErrorState";

const LeadDetail = () => {
  const { id } = useParams();
  const { data: lead, isLoading, error } = useLead(id);

  if (isLoading) {
    return <LoadingState message="Loading lead details..." />;
  }

  if (error) {
    return <ErrorState title="Error loading lead" description={error.message} />;
  }

  if (!lead) {
    return <ErrorState title="Lead not found" description="The requested lead could not be found." />;
  }

  return <LeadDetailComponent />;
};

export default LeadDetail;
